export const create = {
  createSuccessfully: 'Create new uniform successfully!',
}
